import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';

import { environment } from '@fantaz/shared/app-config';
import { Either, left, right } from '@fantaz/shared/data-access/models';

import { ConfigDto } from './config-service.dtos';
import {
  ConfigServiceFailure,
  ConfigServiceFailures,
} from './config-service.failures';
import { Config, ConfigService } from './config-service.interface';

export class ConfigServiceImpl implements ConfigService {
  httpClient: HttpClient = inject(HttpClient);

  fetchConfig(
    options?: object | undefined,
  ): Observable<Either<ConfigServiceFailure, Config>>;

  fetchConfig(): Observable<Either<ConfigServiceFailure, Config>> {
    return this.httpClient
      .get(`${environment.apiBaseUrl}/core/client/api/config`)
      .pipe(
        map((response) =>
          right<ConfigServiceFailure, Config>(
            ConfigDto.fromJson(response).toDomain(),
          ),
        ),
        catchError((err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            return of(
              left<ConfigServiceFailure, Config>(
                ConfigServiceFailures.httpFailure(err, err.status),
              ),
            );
          }

          return of(
            left<ConfigServiceFailure, Config>(
              ConfigServiceFailures.unknown(err),
            ),
          );
        }),
      );
  }
}
